import { render } from "./ResponseList.vue?vue&type=template&id=05fd012d&scoped=true"
import script from "./ResponseList.vue?vue&type=script&lang=js"
export * from "./ResponseList.vue?vue&type=script&lang=js"

import "./ResponseList.vue?vue&type=style&index=0&id=05fd012d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fd012d"]])

export default __exports__